import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const UPDATE_DETAILS_COMPLETED = 'UPDATE_DETAILS_COMPLETED';

export const useOnUpdateDetailsSuccess = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback((detail: {
        formName: string;
    }) => {
        const event = new CustomEvent(UPDATE_DETAILS_COMPLETED, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('update_details:success', handleEvent);

        return () => publicEventsAPIService.off('update_details:success', handleEvent);
    }, [handleEvent]);
};
